/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import {
  FormTemplate,
  FormTemplateSection,
  FormTemplateOption,
  FormTemplateField,
} from 'data/template/template.types';
import { Xdp } from 'data/xdp/xdp.types';
import { NodeData } from 'data/nodes/nodes.types';

export type ListenersIpAddressPortsType = {
  [key:string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'edit') {
    (clonedTemplate.main as FormTemplateSection).fields.ipduId.readOnly = true;
    (clonedTemplate.main as FormTemplateSection).fields.ipAddr.readOnly = true;
    (clonedTemplate.main as FormTemplateSection).fields.port.readOnly = true;
  } else if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

export function adaptTemplateOptions(
  template: FormTemplate | undefined,
  xdp?: Xdp,
  xcipioNodes?: NodeData[]
): FormTemplate | undefined {
  if (template == null) {
    return template;
  }

  const clonedTemplate = cloneDeep(template);
  clonedTemplate.formId = Date.now().toString();

  if (xcipioNodes) {
    setOptionForTemplateSection(
      clonedTemplate.main as FormTemplateSection,
      getXcipioNodes(xcipioNodes),
      'nodeName'
    );
  }

  if (xdp && xdp.nodeName) {
    (clonedTemplate.main as FormTemplateSection).fields.nodeName.initial = xdp.nodeName;
  }

  return clonedTemplate;
}

function setOptionForTemplateSection(
  templateSection: FormTemplateSection,
  options: FormTemplateOption[],
  fieldName: string
) {
  const { fields } = templateSection;
  const templateField = fields[fieldName];
  if (templateField == null || templateField?.options == null || options == null) {
    return;
  }

  setOptionFormTemplateField(templateField, options);
}

function setOptionFormTemplateField(
  templateField: FormTemplateField,
  options: FormTemplateOption[],
) {
  if (options.length > 0) {
    templateField.options?.push(...options);
    templateField.initial = templateField.options?.[0].value;
  } else {
    templateField.initial = '';
  }
}

function getXcipioNodes(
  xcipioNodes: NodeData[]
): FormTemplateOption[] {
  return xcipioNodes?.map((field) => ({
    label: field.nodeName,
    value: field.nodeName,
  }));
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}

export function adaptXdpTemplate(
  template: FormTemplate,
): FormTemplate {

  const clonedTemplate = cloneDeep(template);

  clonedTemplate.key = Date.now().toString();
  clonedTemplate.formId = Date.now().toString();

  return clonedTemplate;
}

export function adaptFormData(
  data: Xdp,
): Xdp {

  return cloneDeep(data);
}

export function adaptXdpFormData(
  xdp: Xdp,
): Xdp {

  const clonedXdp = cloneDeep(xdp);

  return clonedXdp;
}
